module.exports = __webpack_public_path__ + "static/media/a2.68e27fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/thumbnails/a2.png
// module id = 309
// module chunks = 0